import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import MainMenuAdmin from '../pages/MainMenuAdmin.js';
import LevelSelect from '../pages/LevelSelect.js';
import SubLevelSelect from '../pages/SubLevelSelect.js';
import LevelPage1 from '../pages/LevelPage1.js';
import LevelPage2 from '../pages/LevelPage2.js';
import LevelPage3 from '../pages/LevelPage3.js';
import LevelPage4 from '../pages/LevelPage4.js';
import LevelPage5 from '../pages/LevelPage5.js';
import LevelPage6 from '../pages/LevelPage6.js';
import LevelPage7 from '../pages/LevelPage7.js';
import LevelPage8 from '../pages/LevelPage8.js';
import LevelPage9 from '../pages/LevelPage9.js';
import Profile from '../pages/Profile.js';
import VerificationPage from '../pages/VerificationPage.js';
import HowToPlay from '../pages/HowToPlay.js';

const letters = [
    'SMT',
    'PNC',
    'KRB',
    'JFG',
    'HDW',
    'VLY'
];

function Admin(props) {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/'><MainMenuAdmin logout={props.func} /></Route>
                <Route exact path='/Home'><MainMenuAdmin logout={props.func} /></Route>
                <Route path='/Level Select' component={LevelSelect} />
                <Route path='/level1'><SubLevelSelect level={'smt'} /></Route>
                <Route path='/level2'><SubLevelSelect level={'pnc'} /></Route>
                <Route path='/level3'><SubLevelSelect level={'krb'} /></Route>
                <Route path='/level4'><SubLevelSelect level={'jfg'} /></Route>
                <Route path='/level5'><SubLevelSelect level={'hdw'} /></Route>
                <Route path='/level6'><SubLevelSelect level={'vly'} /></Route>

                <Route path='/levelsmt1'><LevelPage1 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt2'><LevelPage2 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt3'><LevelPage3 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt4'><LevelPage4 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt5'><LevelPage5 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt6'><LevelPage6 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt7'><LevelPage7 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt8'><LevelPage8 identification={props.identification} level={1} /></Route>
                <Route path='/levelsmt9'><LevelPage9 identification={props.identification} level={1} /></Route>

                <Route path='/levelpnc1'><LevelPage1 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc2'><LevelPage2 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc3'><LevelPage3 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc4'><LevelPage4 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc5'><LevelPage5 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc6'><LevelPage6 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc7'><LevelPage7 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc8'><LevelPage8 identification={props.identification} level={2} /></Route>
                <Route path='/levelpnc9'><LevelPage9 identification={props.identification} level={2} /></Route>

                <Route path='/levelkrb1'><LevelPage1 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb2'><LevelPage2 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb3'><LevelPage3 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb4'><LevelPage4 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb5'><LevelPage5 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb6'><LevelPage6 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb7'><LevelPage7 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb8'><LevelPage8 identification={props.identification} level={3} /></Route>
                <Route path='/levelkrb9'><LevelPage9 identification={props.identification} level={3} /></Route>

                <Route path='/leveljfg1'><LevelPage1 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg2'><LevelPage2 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg3'><LevelPage3 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg4'><LevelPage4 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg5'><LevelPage5 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg6'><LevelPage6 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg7'><LevelPage7 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg8'><LevelPage8 identification={props.identification} level={4} /></Route>
                <Route path='/leveljfg9'><LevelPage9 identification={props.identification} level={4} /></Route>

                <Route path='/levelhdw1'><LevelPage1 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw2'><LevelPage2 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw3'><LevelPage3 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw4'><LevelPage4 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw5'><LevelPage5 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw6'><LevelPage6 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw7'><LevelPage7 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw8'><LevelPage8 identification={props.identification} level={5} /></Route>
                <Route path='/levelhdw9'><LevelPage9 identification={props.identification} level={5} /></Route>

                <Route path='/levelvly1'><LevelPage1 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly2'><LevelPage2 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly3'><LevelPage3 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly4'><LevelPage4 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly5'><LevelPage5 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly6'><LevelPage6 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly7'><LevelPage7 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly8'><LevelPage8 identification={props.identification} level={6} /></Route>
                <Route path='/levelvly9'><LevelPage9 identification={props.identification} level={6} /></Route>

                <Route path='/Profile'><Profile identification={props.identification} /></Route>
                <Route path='/Verification' component={VerificationPage} />
                <Route path='/HowTo' component={HowToPlay} />
            </Switch>
        </BrowserRouter>
    );
}

export default Admin;